import { debug, observer, pr, React, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";

type IProps = {
    store: CardTanSettingsStore;
};

@observer
export class CardTanSettingsCardsSigning extends React.Component<IProps, {}> {
    render() {
        const signInfo = this.props.store.updateDebitCardsResponse?.signInfo;

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("cardTanSettings.debitCards.signing.action")}</pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onError={async (response: ISigningResponse) => {
                    debug.log("### signing error", response);

                    pushRoute(CardTanSettingsRoutes.CARDS_ERROR);
                    await this.props.store.loadDebitCards();
                }}

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### signing success", response);

                    pushRoute(CardTanSettingsRoutes.CARDS_SUCCESS);
                    await this.props.store.loadDebitCards();
                }}

                onClose={async () => {
                    history.goBack();
                }}

                onRetry={async () => {
                    await this.props.store.updateDebitCards();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsCardsSigning.tsx